import { currentEnv } from './environments';

const isStageEnvironment = currentEnv?.env !== 'PROD';

const milo = isStageEnvironment ? 'https://milo-stage.adobe.io' : 'https://milo.adobe.io';
const jil = isStageEnvironment ? 'https://bps-il-stage.adobe.io/jil-api' : 'https://bps-il.adobe.io/jil-api';
const status = isStageEnvironment ? 'https://status-stage.adobe.io' : 'https://status.adobe.io';
const workfront = 'https://adobeworkfront.grazitti.com/adobe-workfront-case-connector-production';
const miloses = isStageEnvironment ? 'https://miloses-stage.adobe.io' : 'https://miloses.adobe.io';
const zeonUrl = isStageEnvironment ? 'https://zeon-server-stage.adobe.io' : 'https://zeon-server.adobe.io';
const supportInsight = 'http://localhost:3000/api/v1';
const backendUrl = isStageEnvironment ? 'https://oneadobe-ucp-support-insight-ex-v2-deploy-ethos270-4d0c00.stage.cloud.adobe.io' : 'https://oneadobe-ucp-support-insight-ex-v2-deploy-ethos10-40321e.cloud.adobe.io';
const alertService = isStageEnvironment ? 'https://dxoc-alertservice-stage.adobe.io' : 'https://dxoc-alertservice.adobe.io';
// const backendUrl = isStageEnvironment ? 'https://oneadobe-ucp-support-insight-ex-v2-deploy-ethos270-875233.stage.cloud.adobe.io' : 'https://oneadobe-ucp-support-insight-ex-v2-deploy-ethos10-40321e.cloud.adobe.io';
export const commerceSwat = `${backendUrl}/api/v1/swat/recommendations`
export const supportInsightFindings = `${supportInsight}/orgs/ORG_ID/products/PRODUCT_CODE/findings/search`;
export const qualtricsSurvey = 'https://yul1.qualtrics.com/API/v3/surveys/SV_7anHhhXduk69smW/responses';
export const statusSite = isStageEnvironment ? 'https://stage.status.adobe.com' : 'https://status.adobe.com';
export const ads = `/api/ads?page_size=12`;
export const activateCouponCode = isStageEnvironment
    ? 'https://acs-authorization-platform-stage.adobe.io/v1/coupon/redeem'
    : 'https://acs-authorization-platform-prod.adobe.io/v1/coupon/redeem'
export const article = `/api/articles/{{id}}`;
export const awards = `/api/awards?page_size=1000`;
export const bookmarksEvents = `/api/bookmarks?order_by=desc&type=events&page_size=12`;
export const bookmarksGuides = `/api/bookmarks?order_by=desc&type=articles&page_size=12`;
export const bookmarksSkills = `/api/bookmarks?order_by=desc&type=skills&page_size=12`;
export const commerceAccess = `${backendUrl}/api/v1/commerce/parkour/customer/identity`;
export const commerceOrg = `${backendUrl}/api/v1/commerce/parkour/organization/#ORG_ID#/identity`;
export const commerceOrgAccess = `${backendUrl}/api/v1/commerce/parkour/organization/identity`;
export const commerceProduct = `${backendUrl}/api/v1/commerce/parkour/entitlements/#ORG_ID#`;
export const commerceSwatMagento = `${commerceSwat}/magento`;
export const commerceSwatResult = `${commerceSwat}/swat`;
export const contacts = `/api/support/contacts?page_size=200`;
export const courses = `/api/courses?sort=Order+asc&page_size=18&op=or`;
export const coveoCaseAssist = isStageEnvironment
  ? 'https://adobesystemsincorporatednonprod1.org.coveo.com/rest/search/v2?organizationId=adobesystemsincorporatednonprod1'
  : 'https://adobev2prod9e382h1q.org.coveo.com/rest/search/v2?organizationId=adobev2prod9e382h1q';
export const coveoToken = `/api/coveo-token`;
export const developerBoostProductsUrl = 'https://adobejira-connector.grazitti.com/api/product-fields';
export const eccOrg = `${backendUrl}/api/v1/ecc/customer/search`;
export const eventHistory = `${statusSite}/products/`;
export const geo = `/api/geo`;
export const guides = `/api/guides?sort=Order+asc`;
export const industries = `/api/industries?page_size=200&sort=Order`;
export const interests = `/api/interests?page_size=200&sort=Order`;
export const paths = `/api/paths?page_size=200&sort=Order%2CSolution%2CID`;
export const modulePreferences = `${backendUrl}/api/v1/module-preferences`;
export const portalPreference = `${backendUrl}/api/v1/portal-preference`;
export const product_list = `${jil}/v2/organizations/#ORG_ID/products`;
export const profile = `${backendUrl}/api/v1/profile`;
// export const profileNew = `http://localhost:3000/api/v1/profile/new`;
// export const role = `http://localhost:3000/api/v1/profile/role`;
export const profileNew = `${backendUrl}/api/v1/profile/new`;
export const role = `${backendUrl}/api/v1/profile/role`;
export const labels = `/api/labels?page_size=500&sort=id+asc`;
export const levels = `/api/levels?page_size=200&sort=Order`;
export const miloCase = `${milo}/casemgt/c14e/case/v1`;
export const miloCaseAction = `${milo}/casemgt/c14e/case/action/v1`;
export const miloCaseAttachments = `${milo}/attachments/c14e/files/v1`;
export const miloCaseUploadAttachments = `${milo}/attachments/c14e/file/v1`;
export const miloCaseCommentAddition = `${milo}/casemgt/c14e/activities/customernote/v1`;
export const miloCaseCommentList = `${milo}/casemgt/c14e/activities/v1`;
export const miloCaseList = `${milo}/casemgt/c14e/cases/v1`;
export const miloCaseDownloadAttachment = `${milo}/attachments/c14e/file/FILEIDENTIFIER/v1`;
export const miloCaseUpdate = `${milo}/casemgt/c14e/case/v1`;
export const miloEntitlementSync = `${miloses}/supportplan/supportEntitlements/v1`;
export const miloIssueReason = `${milo}/metadata/c14e/case/v1`;
export const miloProductMetadata = `${milo}/metadata/c14e/product/#PRODUCT_CODE/v1`;
export const miloProductMetadataV2 = `${milo}/metadata/c14e/product/#PRODUCT_CODE/v2`;
export const whatsappNotifEligibility = `${alertService}/whatsapp/v1/notif/eligibility`;


export const exlMiloCase = `${backendUrl}/api/v1/milo/case`;
export const exlMiloCaseAction = `${backendUrl}/api/v1/milo/case/action`;
export const exlMiloCaseAttachments = `${backendUrl}/api/v1/milo/case/attachments`;
export const exlMiloCaseUploadAttachments = `${backendUrl}/api/v1/milo/case/attachment`;
export const exlMiloCaseCommentAddition = `${backendUrl}/api/v1/milo/case/comment`;
export const exlMiloCaseCommentList = `${backendUrl}/api/v1/milo/case/comments`;
export const exlMiloCaseList = `${backendUrl}/api/v1/milo/cases`;
export const exlMiloCaseDownloadAttachment = `${backendUrl}api/v1/milo/case/attachment/:fileIdentifier`;
export const exlMiloCaseUpdate = `${backendUrl}/api/v1/milo/case`;
export const exlMiloIssueReason = `${backendUrl}/api/v1/milo/issue-reason`;
export const exlMiloProductMetadata = `${backendUrl}/api/v1/milo/product-metadata/PRODUCT_CODE/v2`;


// export const exlMiloProductMetadata = `{backendUrl}/api/milo/caseProductMetadataC14e`;


// export const exlMiloCase = '/api/milo/caseCreateC14e';
// export const exlMiloCaseAction = '/api/milo/caseActionC14e';
// export const exlMiloCaseAttachments = '/api/milo/caseAttachementListC14e';
// export const exlMiloCaseUploadAttachments = '/api/milo/caseAttachementUploadC14e';
// export const exlMiloCaseCommentAddition = '/api/milo/caseActivityCustomerNoteC14e';
// export const exlMiloCaseCommentList = '/api/milo/caseActivitiesListC14e';
// export const exlMiloCaseList = '/api/milo/caseListC14e';
// export const exlMiloCaseDownloadAttachment = '/api/milo/caseAtachmentDownloadC14e';
// export const exlMiloCaseUpdate = '/api/milo/caseCreateC14e';
// export const exlMiloIssueReason = '/api/milo/caseMetadataC14e';
// export const exlMiloProductMetadata = '/api/milo/caseProductMetadataC14e';


export const orgSession = 'https://adobejira-connector.grazitti.com/api/org-session';
export const requestSession = 'https://adobejira-connector.grazitti.com/api/request-session';
export const roles = '/api/roles?page_size=200&sort=Order';
export const snaplogic = `${backendUrl}/api/v1/snaplogic/exl-support-launch-contacts`;
export const kboActivity = isStageEnvironment ?
'https://stage-support-insights.corp.ethos505-stage-va6.ethos.adobe.net/api/v1/ultimate-gateway'
: 'https://prod-support-insights.adobe.io/api/v1/ultimate-gateway';
export const search = '/api/search?sort=Order+asc&page_size=9&type=articles&type=events&type=skills&future=false';
export const siteSearch = '/api/search?page_size=12&Markdown=true';
export const siteSearchFilters = '/api/solutions?page_size=200&full=true&order_by=SearchGroup%2CSOrder';
export const skills = '/api/skills';
export const solutions = '/api/solutions?page_size=200&full=true&order_by=TOrder%2COrder';
export const statusMessage = `${status}/api/v1/messages`;
export const stream = '/api/stream';
export const support = '/api/support?sort=Order+asc&page_size=9';
export const supportArticles = 'https://platform.cloud.coveo.com/rest/search/v2';
export const supportSolutions = '/api/solutions?page_size=200&full=true&sort=Name+asc';
export const survey = '/api/survey';
export const suscribeStatus = `${statusSite}/subscribe/`;
export const tags = '/api/tags?page_size=200&type=articles&type=events&type=skills&future=false';
export const ticket = '/api/support/case';
export const ticketStatus = `${status}/api/v1/events`;
export const track = `/api/track`;
export const vote = `/api/vote`;
export const watcherMembers = `${jil}/v2/organizations/#ORG_ID/search/members?search_query=#searchquery`;
export const workfrontCaseAttachmentsUpload = `${workfront}/uploadAttachment/`;
export const workfrontCaseAttachmentsDownload = `${workfront}/downloadAttachment`;
export const workfrontCaseClose = `${workfront}/updateCaseStatus`;
export const workfrontCaseCreate = `${workfront}/createCase`;
export const workfrontCaseCreateComment = `${workfront}/createCaseComment`;
export const workfrontCaseCommentList = `${workfront}/getCaseComments`;
export const workfrontCaseDetail = `${workfront}/getCaseDetail`;
export const workfrontCaseEscalate = `${workfront}/escalateCase`;
export const workfrontCaseList = `${workfront}/getCaseList`;
export const workfrontConfig = 'https://adobejira-connector.grazitti.com/admin/api/workfront-config/#ENV#';
export const workfrontConfiguration = `${workfront}/extraConfig.json`;
export const workfrontFieldsList = `${workfront}/getCaseFormFields`;
export const workfrontProductAccessAuth = `${workfront}/checkAuthentication`;
export const getDtpProductRoles = 'https://bps-il.adobe.io/jil-api/v2/organizations/{orgID}/admins/{userID}';
export const zeonAiAgent = `${zeonUrl}/bedrock/agent/ask`;
export const zeonAiAgentFeedback = `${zeonUrl}/bedrock/agent/collectFeedback`;
export const zeonCasePrepare = `${zeonUrl}/bedrock/agentcore/case/prepare`;
